import { SVGProps, Ref, forwardRef } from 'react';

export const GraduationHatFilledSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16 2.667 0 11.903l16 9.237 16-9.237zm0 21.245L4.667 17.369v.103c.01 2.094.134 4.983 1.309 6.715.526.775 1.793 1.63 3.803 2.792 2.712 1.568 4.459 2.354 6.202 2.36h.035c1.744-.005 3.492-.792 6.205-2.36 2.01-1.162 3.278-2.017 3.803-2.792 1.169-1.722 1.298-4.588 1.31-6.68l-.002-.138z"
                fill="currentColor"
            />
        </g>
    </svg>
));
GraduationHatFilledSize32Glyph.displayName = 'GraduationHatFilledSize32Glyph';
